/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Globals from "../shared/Globals";
import { SidebarGlobal } from "./_SidebarGlobal";
import MessageDialog from "./MessageDialog";
import Icon from "./Icon";
import L from "./Lang";
import AppActions from "./AppActions";
import React from "react";
import Auth from "../shared/Auth";
import FormLabel from "./FormLabel";
import Alert from "./Alert";

class InvoiceView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                invoiceDate: new Date(),
                dueDate: new Date(),
                lineItems: [],
                shippingTotal: 0
            },
            saving: false,
            organizations: [],
            accounts: [],
            products: [],
            itemTypes: [
                { id: 'Product', name: 'Product' },
                { id: 'Service', name: 'Service' }
            ]
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submitRef = React.createRef();

        this.submit = this.submit.bind(this);
        this.productChanged = this.productChanged.bind(this);
        this.load = this.load.bind(this);
        this.accountSelected = this.accountSelected.bind(this);
        this.patientSelected = this.patientSelected.bind(this);
        this.fillUnbilled = this.fillUnbilled.bind(this);
    }

    async componentDidMount() {

        qreq.post('/api/organization/list', {}, j => {
            if (j.list)
                this.setState({ organizations: j.list });
        });

        qreq.get('/api/account/list', j => {
            if (j.list)
                this.setState({ accounts: j.list });
        });

        qreq.post('/api/product/list', {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.name);
                    if (!product) {
                        products.push({
                            id: i.name,
                            name: i.name,
                            obj: i,
                            productName: i.productName,
                            isPricePerUnit: i.isPricePerUnit,
                            firstProductID: i.id
                        });
                    }
                    var size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.id, name: i.productSize, productName: i.name, productID: i.id });
                    }
                });
                this.sizes = sizes;
                this.products = products;
                this.setState({ products: products });
                this.load();
            }
        });

        await this.getSettings();
        await this.loadPrimaryAccount();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load() {
        if (this.id) {
            qreq.get('/api/invoice/get/' + this.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    j.item.lineItems.forEach(i => {
                        i.sizes = [];
                        var prod = this.products.find(j => j.id === i.productID);
                        if (prod) {
                            i.productName = prod.name;
                        }
                        this.filterSizes(i, i.productName);
                    });
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
    }

    loadPrimaryAccount = async () => {
        const user = await Auth.getLoginAsync();
        if (user.primaryAccountID) {
            try {
                const j = await qreq.getAsync('/api/account/get/' + user.primaryAccountID);
                if (j.item) {
                    this.setState({ primaryAccount: j.item });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }
        this.setState({ primaryAccountLoaded: true });
    }


    submit(e) {
        if (e)
            e.preventDefault();

        var item = { ...this.state.item };

        item.lineItems.forEach(i => {

            // GEN
            if (this.state.MODEL !== 'WMS' && this.state.MODEL !== 'MNF') {
                var prod = this.state.products.find(j => j.id === Number(i.productID));
                i.productSize = '1x1';
                if (prod)
                    i.productName = prod.productName;
                return;
            }

            var size = this.sizes.find(j => j.id === Number(i.productID));

            if (!size)
                return;

            i.productSize = size.name;
        });

        this.setState({ saving: true });

        item.lineItems.forEach(i => {
            // GEN
            if (this.state.MODEL === 'GEN') {
                i.unitQty = 1;
                return;
            }

            i.unitQty = this.getCm2(i);
            if (i.unitQty === 'N/A')
                i.unitQty = 0;
        });

        item.fromAccountID = this.state.primaryAccount?.id ?? 0;

        qreq.post('/api/invoice/save', item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    getCm2(i, useZeroAsDefault) {
        if (i.productSize) {
            var s = i.productSize.toLowerCase();
            var n = s.indexOf('x');
            if (n > -1) {
                var p = s.split('x');
                if (p.length > 1) {
                    return Number(p[0]) * Number(p[1]);
                }
            }
            return 0;
        }
        return useZeroAsDefault ? 0 : 'N/A';
    }

    filterSizes(obj, sel) {
        if (!sel || !this.sizes) {
            obj.sizes = [];
            return;
        }
        var sizes = [];
        this.sizes.forEach(i => {
            if (i.productName === sel)
                sizes.push(i);
        });
        obj.sizes = sizes;
    }

    productIDChanged(obj, sel) {
        console.log('product', sel);
        const product = this.state.products.find(x => x.name === sel);
        if (product) {
            obj.isPricePerUnit = product.isPricePerUnit;
            if (product.isPricePerUnit)
                this.filterSizes(obj, sel);
            else
                obj.productID = product.firstProductID;
            this.setState({ item: this.state.item });
        }
    }

    productChanged(i, productId) {
        var prod = this.state.products.find(j => j.id === Number(productId));
        if (prod && prod.price)
            i.unitRate = prod.price;
        else
            i.unitRate = 0;
        this.setState({ item: this.state.item });
    }

    addItem = () => {
        let list = [...this.state.item.lineItems];
        list.push({ key: uuidv4(), sizes: [] });
        this.setState({ item: { ...this.state.item, lineItems: list } });
    }

    itemTypeChanged = (v) => {
        //? just in case
    }

    accountSelected(v) {
        qreq.get('/api/account/get/' + v, j => {
            this.setState({ account: j.item });
        });
    }

    patientSelected(v) {
        qreq.get('/api/order/patient/' + v.id, j => {
            if (j.item) {
                if (!this.state.item.id) {
                    this.setState({ order: j.item, item: { ...this.state.item, orderID: j.item.id, accountID: j.item.accountID } });
                    this.fillUnbilled(j.item.accountID);
                    if (j.item.accountID)
                        this.accountSelected(j.item.accountID);
                }
            }
        });
    }

    fillUnbilled(accountID) {
        qreq.get('/api/product/account/' + accountID + '/unbilled', j => {
            if (j.list) {
                var list = [];
                j.list.forEach(i => {
                    if (!i.lotNumber)
                        return;
                    list.push({
                        id: i.id,
                        key: uuidv4(),
                        productID: i.productID,
                        productName: i.productName,
                        lotNumber: i.lotNumber,
                        qty: i.quantity,
                        unitRate: i.unitRate,
                        sizes: [{ id: i.productID, name: i.productSize }]
                    });
                });
                console.log(list);
                this.setState({ item: { ...this.state.item, lineItems: [...list] } });
            }
        });
    }

    change = () => {
        this.setState({
            item: { ...this.state.item }
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Invoice</L></h1><LoadingAlert /></div>);


        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Invoice #{this.state.item.iid}</h1>
                <Breadcrumb path={[['Invoices', '/invoice/list'], [this.id ? 'Edit' : 'New']]} />
                {Auth.hasPolicy('manager') && <Card title="Billing Organization">
                    <FormInput model={this.state.item} name="organizationID" label="Organization" type="select" options={this.state.organizations} required />
                </Card>}
                {!Auth.hasPolicy('manager') && <Card title="Billing Account">
                    {this.state.primaryAccount && <><FormLabel model={this.state.primaryAccount.name} label="Billing Account" />
                        {this.state.primaryAccount.address ? <div className="bg-light rounded mb-3 p-3"><strong>Address:</strong><br />{this.state.primaryAccount.address.line1} {this.state.primaryAccount.address.line2}<br />
                            {this.state.primaryAccount.address.city} {this.state.primaryAccount.address.state} {this.state.primaryAccount.address.country} {this.state.primaryAccount.address.postalCode}</div> : ''}
                    </>}
                    {!this.state.primaryAccount && this.state.primaryAccountLoaded && <Alert type="danger"><L>Primary account is missing. Please contact an Administrator.</L></Alert>}
                </Card>}
                <Card title="Info">


                    {this.state.MODEL === 'WMS' && (this.state.item.patient ?
                        <div className="mb-3">
                            <label className="form-label"><L>Patient</L></label>
                            <div>
                                {this.state.item.patient.name} <span className="btn btn-primary btn-sm d-none" onClick={() => this.setState({ item: { ...this.state.item, patient: null, patientID: 0 } })}><Icon icon="faPencil" /> <L>Edit</L></span>
                            </div>
                        </div>
                        : <FormInput model={this.state.item} name="patientID" label="Patient" type="search" searchUrl="/api/patient/list/ready" onChange={this.patientSelected} />
                    )}





                    <FormInput model={this.state.item} name="accountID" label="Account" type="select" options={this.state.accounts} required onChange={this.accountSelected} />
                    {this.state.account && this.state.account.address ? <div className="bg-light rounded mb-3 p-3"><strong>Address:</strong><br />{this.state.account.address.line1} {this.state.account.address.line2}<br />
                        {this.state.account.address.city} {this.state.account.address.state} {this.state.account.address.country} {this.state.account.address.postalCode}</div> : ''}
                    <div className="row">
                        <div className="col-md-6">
                            <FormInput model={this.state.item} name="invoiceDate" label="Invoice Date" type="date" />
                        </div>
                        <div className="col-md-6">
                            <FormInput model={this.state.item} name="dueDate" label="Due Date" type="date" />
                        </div>
                    </div>
                </Card>
                <Card title="Payment">
                    <FormInput model={this.state.item} name="paid" label="Paid" type="number" step="0.01" />
                </Card>
                <Card title="Line Items">
                    <table className="table">
                        <thead>
                            <tr>
                                <th><L>Item</L></th>
                                <th><L>Description</L></th>
                                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && <th><L>Size</L></th>}
                                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && <th><L>Lot #</L></th>}
                                {(this.state.MODEL !== 'WMS' && this.state.MODEL !== 'MNF') && <th><L>Item Name</L></th>}
                                <th><L>Qty</L></th>
                                <th><L>Unit Price</L></th>
                                <th><L>Total Units</L></th>
                                <th><L>Amount</L></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.item.lineItems.map(i => <tr key={i.id ?? i.key} className="align-baseline">
                                <td>
                                    <FormInput model={i} name="itemType" label="Item Type" type="select" disableSelectDefault
                                        labelAsPlaceholder required options={this.state.itemTypes} onChange={this.itemTypeChanged} />
                                </td>
                                <td><FormInput model={i} name="productName" label="Product" type="select" optionsName="productName" labelAsPlaceholder required options={this.state.products} onChange={obj => this.productIDChanged(i, obj)} /></td>
                                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && <td>{i.isPricePerUnit ? <FormInput model={i} name="productID" label="Size" type="select" labelAsPlaceholder required options={i.sizes} onChange={() => this.setState({ item: this.state.item })} /> : 'Standard'}</td>}
                                {(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && <td><FormInput model={i} name="lotNumber" label="LOT#" type="text" labelAsPlaceholder onChange={() => this.setState({ item: this.state.item })} /></td>}
                                {(this.state.MODEL !== 'WMS' && this.state.MODEL !== 'MNF') && <td><FormInput model={i} name="lotNumber" label="Item Name" type="text" labelAsPlaceholder onChange={() => this.setState({ item: this.state.item })} /></td>}
                                <td><FormInput model={i} name="qty" label="0" type="number" step="1" labelAsPlaceholder required onChange={() => this.setState({ item: this.state.item })} /></td>
                                <td><FormInput model={i} name="unitRate" label="0.00" preInput="$" type="number" step="0.01" labelAsPlaceholder required onChange={() => this.setState({ item: this.state.item })} initValue={i.unitRate} /></td>
                                <td>{this.getCm2(i) !== 'N/A' && i.qty > 0 ? (this.getCm2(i) * i.qty) : 'N/A'}{(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') && i.isPricePerUnit && i.productSize ? <><L>cm</L><sup><L>2</L></sup></> : ''}</td>
                                <td>{this.getCm2(i) !== 'N/A' ? Globals.getCurrencyFormatter().format(i.unitRate * this.getCm2(i, true) * i.qty) : ''}</td>
                                <td><button type="button" className="btn btn-outline-danger" onClick={() => this.removeFromList(this.state.item.lineItems, i)}><FontAwesomeIcon icon={fa.faTrash} /></button></td>
                            </tr>)}
                            {this.state.item.hasShipping && <tr className="align-baseline">
                                <td colspan={(this.state.MODEL === 'WMS' || this.state.MODEL === 'MNF') ? 4 : 3}></td>
                                <td className="text-end"><L>Shipping Total</L></td>
                                <td><FormInput model={this.state.item} name="shippingTotal" label="0.00" preInput="$" type="number" step="0.01" labelAsPlaceholder required onChange={() => this.setState({ item: this.state.item })} /></td>
                                <td colSpan="2"></td>
                                <td><button type="button" className="btn btn-outline-danger" onClick={() => this.setState({ item: { ...this.state.item, hasShipping: false, shippingTotal: 0 } })}><FontAwesomeIcon icon={fa.faTrash} /></button></td>
                            </tr>}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-start gap-1">
                        <button type="button" className="btn btn-primary" onClick={this.addItem}><FontAwesomeIcon icon={fa.faPlus} /><L>Append Line Item</L></button>
                        {!this.state.item.hasShipping
                            && <button type="button" className="btn btn-secondary" onClick={() => this.setState({ item: { ...this.state.item, hasShipping: true, shippingTotal: 0 } })}><FontAwesomeIcon icon={fa.faPlus} /><L>Add Shipping</L></button>}
                    </div>
                </Card>
                <Card title="Tax Settings">
                    <div className="row">
                        <div className="col-md-6">
                            <FormInput model={this.state.item} name="isTaxEnabled" label="Apply tax to this invoice." type="switch" onChange={this.change} />
                        </div>
                        {this.state.item.isTaxEnabled && <div className="col-md-6">
                            <FormInput model={this.state.item} name="taxPercent" label="Tax Percent" type="text" step="0.01" placeholder="0.0" postAddon="%" required />
                        </div>}
                    </div>
                </Card>
                {this.state.saving && <MessageDialog title="Saving" message="Processing..." />}
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg" ref={this.submitRef}>
                        <Icon icon="faSave" /> <L>Save</L>
                    </button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParams(InvoiceView);